var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VehicleForm',{attrs:{"disabled":_vm.disabled,"entityVehicle":_vm.entityMpVehicle.getEntityVehicle()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }